import * as React from "react";
import { ITicketGroup, ITicketGroupRequest, ITicketGroupCategory } from "@nkr/models/index";
import { Modal, Button, FormGroup, FormControl, ControlLabel, Glyphicon, Alert } from "react-bootstrap";
import styled from "styled-components";

const CheckBoxWrapper = styled.div`
    :hover {
        text-decoration: underline;
        cursor: pointer;
    }
`;

interface IProps {
    show: boolean,
    data: ITicketGroup,
    categories: ITicketGroupCategory[],
    onSave: (group: ITicketGroupRequest) => void,
    onCancel: () => void
}

interface IState {
    id: number,
    name: string,
    isNkr: boolean,
    category: number,
    valid: {
        name: boolean,
        category: boolean
    }
}

class GroupAddEdit extends React.Component<IProps, IState> {
    readonly state: IState = {
        id: 0,
        name: "",
        isNkr: false,
        category: 0,
        valid: {
            name: true,
            category: true
        }
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.data != null) {
            let { id, name, isNkr, category } = nextProps.data;

            this.setState({
                id,
                name,
                isNkr,
                category
            });
        } else {
            this.setState({
                name: '',
                isNkr: false,
                category: 0,
                valid: {
                    name: true,
                    category: true
                }
            });
        }
    }

    handleNameChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            name: e.currentTarget.value
        });
    }

    handleCategoryChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            category: parseInt(e.currentTarget.value)
        });
    }

    handleIsNkrClick = () => {
        this.setState({
            isNkr: !this.state.isNkr
        });
    }

    handleSave = () => {
        let { id, name, isNkr, category } = this.state;

        this.setState({
            valid: {
                name: name != "",
                category: category != 0
            }
        }, () => {
            if (this.state.valid.name && this.state.valid.category) {
                let request: ITicketGroupRequest = {
                    id,
                    name,
                    isNkr,
                    category,
                    users: []
                };

                this.props.onSave(request);
            }
        });
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        if (this.props.data == null && this.props.show == false)
            return null;

        const title = this.state.id > 0 ? <>Edit Group: <strong>{this.state.name}</strong></> : <>Add Group</>;

        return (
            <>
                <Modal show={this.props.show} onHide={() => null}>
                    <Modal.Header className="h4">
                        {title}
                    </Modal.Header>

                    <Modal.Body>
                        {(this.state.valid.name == false || this.state.valid.category == false) && (
                            <Alert bsStyle="danger" style={{ padding: "7.5px 15px" }}>
                                Please correct the issues below...
                            </Alert>
                        )}

                        <FormGroup validationState={this.state.valid.name ? null : "error"}>
                            <ControlLabel>Name</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Enter the name of the group"
                                value={this.state.name}
                                onChange={this.handleNameChange}
                            />
                        </FormGroup>

                        <FormGroup validationState={this.state.valid.category ? null : "error"}>
                            <ControlLabel>Category</ControlLabel>
                            <FormControl
                                componentClass="select"
                                value={this.state.category}
                                onChange={this.handleCategoryChange}
                            >
                                <option value={0}>- select category -</option>
                                {this.props.categories.map((category, index) =>
                                    <option key={index} value={category.id}>{category.description}</option>
                                )}
                            </FormControl>
                        </FormGroup>

                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5 }}><Glyphicon glyph={this.state.isNkr ? "check" : "unchecked"} onClick={this.handleIsNkrClick} /></div>
                            <CheckBoxWrapper onClick={this.handleIsNkrClick}>Internal Group</CheckBoxWrapper>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={this.handleSave}>Save</Button>
                        <Button onClick={this.handleCancel}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default GroupAddEdit;